import type BackOfficeConnector from "../data/backOfficeConnector";
import type EventBus from "../services/eventBus";
import RepositoryBase from "./repositoryBase";

export default class NewVersionRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, eventBus: EventBus) {
    super(() => apiFactory({ onlyBaseUrl: true }), eventBus);
  }

  getVersion(): Promise<{ version: string }> {
    return this.callApi(api => api.all(`version.json?ver=${new Date().getTime()}`).get());
  }
}
